export enum enumWizardComponent {
  invoiceFormDesktopComponent,
  entityUnifyDefaultDesktopComponent,
  lineItemFormDesktopComponent,
}
